import { competitionList } from '../constant/RegisterPageConst';

const categoryLabels = new Map(Object.values(competitionList).map(label => [label.toLowerCase(), label]));

// Summarize complete group membership, independent of roster/search filters.
export const getGroupRegistrantSummary = (registrants = []) => {
    const events = new Map([['APCS2025', 0], ['APCS2026', 0]]);
    const categories = new Map();
    registrants.forEach(registrant => {
        // Missing documents are placeholders, not legacy APCS2025 registrations.
        const eventId = registrant.missing ? 'Unknown event' : registrant.eventId || 'APCS2025';
        const rawCategory = String(registrant.competitionCategory || '').trim();
        const categoryKey = registrant.missing ? 'registrant unavailable' : rawCategory.toLowerCase() || 'not set';
        if (!categories.has(categoryKey)) categories.set(categoryKey, {
            label: registrant.missing ? 'Registrant unavailable' : categoryLabels.get(categoryKey) || rawCategory || 'Not set',
            total: 0,
            events: {},
        });
        events.set(eventId, (events.get(eventId) || 0) + 1);
        const category = categories.get(categoryKey);
        category.total += 1;
        category.events[eventId] = (category.events[eventId] || 0) + 1;
    });
    return {
        total: registrants.length,
        events: [...events].map(([eventId, count]) => ({ eventId, count })),
        categories: [...categories.values()].sort((a, b) => a.label.localeCompare(b.label)),
    };
};
